import { render, staticRenderFns } from "./last-page.vue?vue&type=template&id=7590efe1&scoped=true&"
import script from "./last-page.vue?vue&type=script&lang=js&"
export * from "./last-page.vue?vue&type=script&lang=js&"
import style0 from "./last-page.vue?vue&type=style&index=0&id=7590efe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590efe1",
  null
  
)

export default component.exports